enum DesktopMenuTextKeys {
	FEATURED_LINKS_LABEL = 'SPORTSBOOK_FEATURED_LINKS_LABEL',
	ALL_SPORTS_LABEL = 'SPORTSBOOK_ALL_SPORTS_LABEL'
}

export const DESKTOP_MENU_TEXT_KEYS = Object.values(DesktopMenuTextKeys);

export default DesktopMenuTextKeys;
